export default __webpack_public_path__ + "static/media/white-logo@2x.615725cd.png";